import { FundsTransferPageHeader } from "../components/FundsTransfer/shared/FundsTransferPageHeader";
import { WithdrawalFlowContainer } from "../components/FundsTransfer/shared/WithdrawalFlowContainer";
import { PAYOUT_ACCOUNT_TYPES } from "../components/FundsTransfer/config/fundsTransferConfig";

function FundsTransferMobileMoney() {
  return (
    <div className="p-6">
      <FundsTransferPageHeader />
      <WithdrawalFlowContainer
        withdrawalType={PAYOUT_ACCOUNT_TYPES.MOBILE_MONEY}
      />
    </div>
  );
}

export default FundsTransferMobileMoney;
